'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleSwitcher = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _supportedLocales = require('locales/supported-locales.json');

var _supportedLocales2 = _interopRequireDefault(_supportedLocales);

var _multitrack = require('helpers/multitrack');

var _verify = require('helpers/verify');

var _DisclosureArrow = require('components/DisclosureArrow/DisclosureArrow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageNames = {
  'fr-FR': 'Français',
  'en-US': 'English (United States)',
  'en-AU': 'English (Australia)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands'
};

var LocaleSwitcher = exports.LocaleSwitcher = function (_React$Component) {
  (0, _inherits3.default)(LocaleSwitcher, _React$Component);

  function LocaleSwitcher() {
    (0, _classCallCheck3.default)(this, LocaleSwitcher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocaleSwitcher.__proto__ || (0, _getPrototypeOf2.default)(LocaleSwitcher)).call(this));

    _this.localeClicked = _this.localeClicked.bind(_this);
    _this.onCloseModal = _this.onCloseModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LocaleSwitcher, [{
    key: 'onCloseModal',
    value: function onCloseModal() {
      var currentLocale = this.getCurrentLocale();
      (0, _multitrack.ga)('Footer', 'Click - Close Locale Modal', currentLocale);
      this.props.hideModal('LocaleModal');
    }
  }, {
    key: 'getCurrentLocale',
    value: function getCurrentLocale() {
      var currentLocale = this.props.intl.locale;


      return currentLocale;
    }
  }, {
    key: 'localeClicked',
    value: function localeClicked() {
      var currentLocale = this.getCurrentLocale();
      this.props.showModal('LocaleModal', {
        currentLocale: currentLocale,
        locales: this.locales(),
        onModalClose: this.onCloseModal,
        onSelect: this.props.updateAccountLocale
      });
      (0, _multitrack.ga)('Footer', 'Click - Current Locale', currentLocale);
    }
  }, {
    key: 'locales',
    value: function locales() {
      return _supportedLocales2.default.map(function (locale) {
        return {
          languageName: languageNames[locale],
          localeKey: locale
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      var currentLocale = this.getCurrentLocale();
      var locales = this.locales();

      if ((0, _verify.isEmpty)(locales)) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { className: className },
        children({
          name: languageNames[currentLocale],
          locale: currentLocale,
          onClick: this.localeClicked
        })
      );
    }
  }]);
  return LocaleSwitcher;
}(_react2.default.Component);

LocaleSwitcher.defaultProps = {
  className: 'LocaleSwitcher',
  children: function children(_ref) {
    var locale = _ref.locale,
        onClick = _ref.onClick,
        name = _ref.name;
    return _react2.default.createElement(
      'a',
      {
        key: locale,
        onClick: onClick
      },
      name,
      _react2.default.createElement(_DisclosureArrow.DisclosureArrow, {
        className: 'LocaleSwitcher__arrow',
        svgClassName: 'LocaleSwitcher__arrow__svg'
      })
    );
  }
};

LocaleSwitcher.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.func,
  hideModal: _propTypes2.default.func,
  showModal: _propTypes2.default.func,
  updateAccountLocale: _propTypes2.default.func.isRequired
};